module.exports = __webpack_public_path__ + "media/application/images/company/founders-bw/Colin-Stove-158d9a765a3e9af164c4a91606f23946.jpg";